import IAudio from "./IAudio";
import SystemConfig, { CONFIG_PARAMS } from "../system/SystemConfig";
import InitResult from "../connect/result/InitResult";
import { injectable } from "inversify";
import events from "../events/EventsObservable";
import { EVENTS } from "../events/baseEvents";
import { SCREEN_EVENTS } from "../ui/screen/AbstractUIScreen";
import Settings from "../settings/Settings";

export const AUDIO_EVENTS = {
	AUDIO_MUTED: "AUDIO_MUTED",
};

@injectable()
export default abstract class AbstractAudio implements IAudio {
	protected choosed: boolean = false;
	protected muted: boolean = true;
	private mutedTmp: boolean = true;

	protected config: SystemConfig;
	protected gameset: any;
	protected gamesetTracks: any[];

	protected _lockVolumes: boolean = false;

	protected constructor(config: SystemConfig) {
		this.config = config;
		this.gameset = config.gameset;

		this.gamesetTracks = [];
		this.gamesetTracks = this.gamesetTracks.concat(
			this.gameset.system.audio.tracks
		);
		this.gamesetTracks = this.gamesetTracks.concat(
			this.gameset.game.audio.tracks
		);

		events.subscribe(EVENTS.PREINIT_SUCCESS, (eventName, settings) =>
			this.onInitSuccess(settings)
		);
		events.subscribe(
			SCREEN_EVENTS.SCREEN_VISIBILITY_CHANGE,
			(eventName, data) => this.visibilityChange(data.focus)
		);
	}

	setChoosed(choosed: boolean) {
		this.choosed = choosed;
	}

	abstract onInitSuccess(settings: Settings);

	abstract loadComplete(data: any);

	abstract audioFadeIn(duration: number, easing?: Function);

	abstract mute(): boolean;

	abstract unmute(): boolean;

	abstract isPlaying(name: string): boolean;

	abstract getTrackNames(): string[];

	abstract fadeOutTrack(name, duration, stop?, callback?, ease?);

	abstract fadeInTrack(name, duration, from?, callback?, ease?);

	lockVolumes() {
		this._lockVolumes = true;
	}
	unlockVolumes() {
		this._lockVolumes = false;
	}

	unmuteAllowed(): boolean {
		if (!this.choosed) return false;

		return !this.config.get(CONFIG_PARAMS.MUTE);
	}

	isMuted(): boolean {
		return this.muted;
	}

	toggle(): boolean {
		if (!this.muted) {
			this.mute();
			return false;
		}

		this.unmute();
		return true;
	}

	protected visibilityChange(focus: boolean) {
		if (!this.choosed) {
			return;
		}

		focus ? this.visibilityUnMute() : this.visibilityMute();
	}

	protected visibilityMute() {
		this.mutedTmp = this.muted;
		this.mute();
	}

	protected visibilityUnMute() {
		if (this.mutedTmp) return;
		this.unmute();
	}

	abstract playTrack(name: string, vol?: number);

	abstract getDefaultVolume(name, vol?: number): number;

	abstract getVolume(name: string);
}
